module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.fordeling"
    }
  }), _vm._v("\n        Fordeling mellem time- og vareforbrug (kostpriser)\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.timeloggings.total > 0 && _vm.data.materials.total > 0) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data),
      expression: "data"
    }],
    staticClass: "timeloggings",
    style: ('width:' + _vm.data.timeloggings.percent + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "timeloggings-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.timeloggings.percent)) + " %\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "materials-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.materials.percent)) + " %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.timeloggings.total)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.materials.total)) + "\n                ")])])])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne fordelingen af udgifter. Tjek, at du har angivet hvilke medarbejdere, der skal regnes med i denne udregning. Dette kan du ændre i indstillinger under \"Medarbejdere\"\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explainer bold"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_c('i', {
    staticClass: "fas fa-clock fa-fw"
  }), _vm._v("\n                    Timer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    Materialer\n                    "), _c('i', {
    staticClass: "fas fa-wrench fa-fw"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1837e2a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1837e2a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/costsDivision.vue
// module id = 789
// module chunks = 0